import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';

export const cardTableLayoutStyles: SxProps<Theme> = {
  minWidth: 750,
  borderCollapse: 'separate !important',
  borderSpacing: '0 12px !important', // Distanza netta tra le singole schede (isole)
  backgroundColor: '#ffffff !important',
  '& .MuiTableBody-root': {
    backgroundColor: 'transparent'
  },
  '& .MuiTableRow-root': {
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease-in-out',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.03)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f8fafc !important', // Grigio chiarissimo elegante (Slate 50)
      boxShadow: '0px 4px 12px rgba(15, 23, 42, 0.05)', // Opzionale: aumenta l'ombra per un effetto sollevamento
      transform: 'translateY(-1px)' // Opzionale: micro-movimento verso l'alto tridimensionale
    }
  },
  '& .MuiTableCell-root': {
    borderTop: '1px solid #e2e8f0 !important',
    borderBottom: '1px solid #e2e8f0 !important',
    padding: '16px 24px',
    fontSize: '0.925rem',
    color: '#0f172a',
    // Arrotonda l'estremità sinistra della scheda
    '&:first-of-type': {
      borderTopLeftRadius: '8px !important',
      borderBottomLeftRadius: '8px !important',
      borderLeft: '1px solid #e2e8f0 !important'
    },
    // Arrotonda l'estremità destra della scheda
    '&:last-of-type': {
      borderTopRightRadius: '8px !important',
      borderBottomRightRadius: '8px !important',
      borderRight: '1px solid #e2e8f0 !important'
    }
  }
};
